export default function SUMIF() {
  return (
    <div className="p-4">
      <h1>SUMIF</h1>
    </div>
  );
}
